import PropTypes from 'prop-types';
import React, { Component } from 'react';

import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';

import Form from './Form';

class EditFeedLayout extends Component {
  static propTypes = {
    fetchSettings: PropTypes.func.isRequired,
    isFinished: PropTypes.bool.isRequired,
    updateFeedLayout: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { fetchSettings } = this.props;

    fetchSettings();
  }

  render() {
    const { isFinished, updateFeedLayout } = this.props;

    if (!isFinished) {
      return null;
    }

    return (
      <SettingsPage>
        <SettingsPageHeader>
          <SettingsPageTitle>
            Компоновка главной ленты приложения
          </SettingsPageTitle>
        </SettingsPageHeader>
        <SettingsPageContent>
          <Form onSubmit={updateFeedLayout} />
        </SettingsPageContent>
      </SettingsPage>
    );
  }
}

export default EditFeedLayout;
